module.exports = __webpack_public_path__ + "img/project10_11.8170080d.jpg";